/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


(function () {
    var app = angular.module('menuAllSites', ['ngMaterial', 'ngMessages']);
    sessionStorage.setItem('plugindir','wp-content/plugins/menu_all_sites/');
    
    
    app.config(['$mdThemingProvider', function ($mdThemingProvider) {
        'use strict';

        $mdThemingProvider.theme('default')
          .primaryPalette('blue');
    }]);
})();